import { render, staticRenderFns } from "./PrinterQueueDetail.vue?vue&type=template&id=637aecea&scoped=true"
import script from "./PrinterQueueDetail.vue?vue&type=script&lang=js"
export * from "./PrinterQueueDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637aecea",
  null
  
)

export default component.exports